import toastr from 'toastr';
import Service from '../../../utility/Service';

export const CREATE_PROMOCODE_SUCCESS = "CREATE_PROMOCODE_SUCCESS";
export const CREATE_PROMOCODE_FAILURE = "CREATE_PROMOCODE_FAILURE";
export const CREATE_PROMOCODE_REQUEST = "CREATE_PROMOCODE_REQUEST";
export const CREATE_PROMOCODE_RESET = "CREATE_PROMOCODE_RESET";


export const promoCodeCreateFailure = () => ({
    type: CREATE_PROMOCODE_FAILURE,
    loading: true,
    created: false,
    promoCodeCreatedData: []
});

export const promoCodeCreateSuccess = (data, pageNo, pageSize) => ({
    type: CREATE_PROMOCODE_SUCCESS,
    loading: false,
    created: true,
    promoCodeCreatedData: data

});

export const promoCodeCreateRequest = () => ({
    type: CREATE_PROMOCODE_REQUEST,
    loading: true,
    created: false,
    promoCodeUpdatedData: []
});

export const promoCodeCreateReset = () => ({
    type: CREATE_PROMOCODE_RESET,
    loading: false,
    created: false,
    promoCodeUpdatedData: []
});

export const createPromoCode = (values, pageNo, pageSize) => (dispatch, getState) => {
    toastr.remove()
    dispatch(promoCodeCreateRequest())
    let url = "promo_code"
    Service.post(url, values,
        (response) => {
            if (response && response.status && response.status === 200) {
                let data = {
                    data: response.data,
                    pagination: response.pagination
                }
                dispatch(promoCodeCreateSuccess(data));
                dispatch(promoCodeCreateReset());

            } else {
                dispatch(promoCodeCreateFailure());
                toastr.error('Something Went Wrong');
            }
        }
    )
};





